import styles from "./SiteFooter.module.css";

interface SiteFooterProps {
  lastUpdated: string;
  reviewNotes: string;
}

export function SiteFooter({ lastUpdated, reviewNotes }: SiteFooterProps) {
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div>
          <p className={styles.brand}>Best Pottery Studios NYC</p>
          <p className={styles.copy}>
            Editorial comparison site for NYC ceramics studios.
          </p>
          <p className={styles.review}>
            Last reviewed {lastUpdated}. {reviewNotes}
          </p>
        </div>
        <div className={styles.links}>
          <a href="#rankings">Rankings</a>
          <a href="#criteria">Methodology</a>
          <a href="/rankings.json">Rankings JSON</a>
        </div>
      </div>
    </footer>
  );
}
